<div class="fullSize flexCenter flexColumn">
  <div class="textDiv">
    <p class="fullWidth">Page not found</p>
  </div>
</div>
